<template>
  <span
    class="style"
    :class="cssClasses"
  >
    <template
      v-if="!isLink"
    >{{ content.text }}</template>
    <template v-else><a :href="linkUrl" target="_blank" rel="noopener noreferrer nofollow">{{ content.text }}</a></template>
  </span>
</template>

<script>
export default {
  name: 'StyledContent.vue',
  props: ['content'],
  computed: {
    isLink () {
      return this.checkMarks(this.content.marks, 'link')
    },
    cssClasses () {
      if (this.isLink) return {}
      return {
        bold: this.checkMarks(this.content.marks, 'bold'),
        italic: this.checkMarks(this.content.marks, 'italic'),
        underline: this.checkMarks(this.content.marks, 'underline'),
        strike: this.checkMarks(this.content.marks, 'strike')
      }
    },
    linkUrl () {
      if (this.isLink) {
        const link = this.content.marks.find(mark => mark.type === 'link')
        if (link) return link.attrs.href
      }
      return ''
    }
  },
  methods: {
    checkMarks (marks, target) {
      const index = marks.findIndex(mark => mark.type === target)
      return index >= 0
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
